export default __webpack_public_path__ + "static/media/logo_dark3.99af35e2.png";